var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReportView',{attrs:{"title":"Informe control revisiones PIC"}},[_c('PicRevisionReport')],1)}
var staticRenderFns = []

export { render, staticRenderFns }